/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BookingSource {
  Unknown = 'Unknown',
  Invitation = 'Invitation',
  Timeslot = 'Timeslot',
  WaitingRoom = 'WaitingRoom'
}
